package pl.mothdigital.neuronowi.common.model

import androidx.compose.runtime.*

/**
 * Data class representing a section of content on a therapy page.
 *
 * @param title Section title (e.g., "Czym jest terapia?")
 * @param content Text content for the section
 */
data class TherapySection(
    val title: String,
    val content: String
)

/**
 * Data class representing all content for a therapy page.
 * Enables data-driven therapy pages instead of hardcoded layouts.
 *
 * @param title Main page title (e.g., "Terapia miofunkcjonalna")
 * @param icon Icon to display in the header
 * @param description Short description shown in header
 * @param sections List of content sections for the page
 * @param metaDescription SEO meta description (optional, defaults to description if not provided)
 * @param ogImage Open Graph image path for social sharing (optional)
 */
data class TherapyPageContent(
    val title: String,
    val icon: @Composable () -> Unit,
    val description: String,
    val sections: List<TherapySection>,
    val metaDescription: String? = null,
    val ogImage: String? = null
)
